const Blog_reducer = (state , action )=>{
       switch(action.type){
         case 'SET_BLOG_API':
            return {
           ...state,
           Blogdata : action.payload,
            };
            case "SET_SINGLE_BLOG":
                return{
                ...state,
                singleblog : action.payload ? [action.payload] : []
                };
             case 'SET_All_BLOG_API':
                return{
                    ...state,
                    Allblogdata : action.payload,
                    filterblogdata:[...action.payload],  
                    duplicateblog:[...action.payload],                
                } 
             case "UPDATE_FILTER":
                const {name , value}  = action.payload;
                   console.log(name , value);
                if (name === 'categoryname') {
                    let updatedCategories = [...state.filters.categoryname];
                    if (updatedCategories.includes(value)) {
                        updatedCategories = updatedCategories.filter((item) => item !== value);
                    } else {
                        updatedCategories.push(value);
                    }
                    return {
                        ...state,
                        filters: {
                            ...state.filters,
                            categoryname: updatedCategories, 
                        },
                    };
                }
                return{
                    ...state,
                    filters: {
                    ...state.filters,
                    [name]: value,
                    },
                }
             case "FILTER_BLOG_TAG":
                const {tagname ,  tagvalue} = action.payload;
                  return{
                    ...state,
                    filters:{
                       ...state.filters,
                       [tagname] : tagvalue ,
                    }
                  }

              case "SET_BLOG_FILTER":
                let {filterblogdata} = state;
                let tempfilterblog = [...filterblogdata];
                const {text , categoryname , Tag} = state.filters;

                if(text){
                    tempfilterblog = tempfilterblog.filter((curElm)=>{
                        return curElm.title.toLowerCase().includes(text);                        
                    })
                }
                if(categoryname && categoryname.length > 0){
                    tempfilterblog = tempfilterblog.filter
                    ((curelm)=>categoryname.includes(curelm.blogcategory)
                  );
               }
               if(Tag){
                tempfilterblog = tempfilterblog.filter((curdata)=>{
                    return  curdata.Tag === Tag ;     
                })
               }
                 return {
                     ...state,
                     duplicateblog : tempfilterblog,
                 }
                 case "SET_ALL_DATA":
                    
                    return {
                        ...state,
                       duplicateblog:state.Allblogdata , 
                    }
                default:
                    return state;

                  
                
    }
}

export default Blog_reducer;